import { JRCInputImage } from 'components/Form/Input/JRCInputImage/JRCInputImage';

import { jFileLittle } from 'jamespot-user-api';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import styled, { useTheme } from 'styled-components';

const InputImageWrapper = styled.div`
    width: 50%;
    margin: 0 auto 20px auto;
`;

type FileFormValues = { file: jFileLittle };

type EditorImageUploadProps = {
    token: string;
    onUploadSuccess: (file: jFileLittle) => void;
    initialFile?: jFileLittle;
};

export const EditorInputImage = ({ token, onUploadSuccess, initialFile }: EditorImageUploadProps) => {
    const { control, watch } = useForm<FileFormValues>({ defaultValues: { file: initialFile } });
    const theme = useTheme();

    useEffect(() => {
        const subscription = watch((data: any) => {
            if (data.file) {
                onUploadSuccess(data.file);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, onUploadSuccess]);

    return (
        <>
            <InputImageWrapper>
                <JRCInputImage
                    zIndex={theme.zIndex.tinyMCEModal}
                    control={control}
                    name={'file'}
                    token={token}
                    attrName={'editorFiles'}
                    accept={'jpg,jpeg,png,gif'}
                    aspectRatio={16 / 9}
                />
            </InputImageWrapper>
        </>
    );
};
